import React, { useMemo } from 'react'
import { styled } from '@pergas-common/pergas-components'
import { useDispatch } from 'react-redux'

const SelectHolder = styled.div`
  width: 100%;
  margin: 8px 0;
  position: relative;
  display: flex;
  flex-direction: column-reverse;
  > span {
    margin-left: 8px;
    ${({ theme }) => theme.typography.breadcrumb}
    color: #3a4a54;
  }
`

const Select = styled.select`
  width: 100%;
  padding: 8px;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  &:focus {
    border-color: #007bff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }
`

const Option = styled.option`
  padding: 8px;
  background-color: #fff;
  color: #000;
  &:hover {
    background-color: #f0f0f0;
  }
`

const ContactPersonDropdown = ({
  contactPersons,
  employees,
  contactAddress,
  contactName,
  onChangeInput
}) => {
  const dispatch = useDispatch()
  const optionGroups = useMemo(() => {
    const personOptions = Array.isArray(contactPersons) ? contactPersons : []
    const employeeOptions = Array.isArray(employees) ? employees : []
    const groups = []

    if (contactAddress) {
      groups.push({
        label: 'Klientadress',
        options: [{
          id: 'contact-address',
          person_id: 'contact-address',
          person_collection_name: contactName ?? '',
          person_name: contactName ?? 'Kontaktadress',
          role_name: 'Klientadress',
          person_address: contactAddress?.address ?? '',
          person_postal_code: contactAddress?.postal_code ?? '',
          person_city: contactAddress?.city ?? '',
          person_email: contactAddress?.email ?? '',
          person_phone: contactAddress?.phone ?? '',
          person_homepage: contactAddress?.homepage ?? ''
        }]
      })
    }

    if (personOptions.length > 0) {
      groups.push({
        label: 'Kontaktpersoner',
        options: personOptions
      })
    }

    if (employeeOptions.length > 0) {
      groups.push({
        label: 'Medarbetare',
        options: employeeOptions
      })
    }

    return groups
  }, [contactPersons, employees, contactAddress, contactName])

  const flatOptions = useMemo(() => optionGroups.flatMap((group) => group.options), [optionGroups])

  return (
    <SelectHolder>
      <Select onChange={(event) => {
        const selectedId = event.target.value
        const selectedPerson =
          flatOptions.find((item) => String(item?.id ?? item?.person_id) === selectedId) ||
          flatOptions.find((item) => String(item?.person_id ?? item?.id) === selectedId)

        onChangeInput(selectedId)
        dispatch({
          type: 'SET_DOCUMENT_DATA_ACTION',
          key: 'selectedPersonRole',
          value: selectedPerson || {}
        })
      }}
      >
        <Option value=''>Välj adressat</Option>
        {optionGroups.map((group) => (
          <optgroup key={group.label} label={group.label}>
            {group.options.map((item) => (
              <Option key={item.id || item.person_id} value={item.id ?? item.person_id}>{item.person_name} ({item.role_name})</Option>
            ))}
          </optgroup>
        ))}
      </Select>
    </SelectHolder>
  )
}

export default ContactPersonDropdown
